<template>
  <div class="recent-view">
    <div class="container-fluid">
      <section>
        <iframe
          v-if="canPlay"
          class="w-100"
          style="height: 70vh; aspect-ratio: 16/9"
          allowfullscreen
          :src="game.url"
          ref="videoFrame"
          loading="lazy"
        ></iframe>

        <div
          v-else
          class="w-100 d-flex align-items-center justify-content-center"
          style="
            height: 70vh;
            background-color: #262653;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-image: `url(${game.thumb_1}) `;
          "
        >
          <h1
            class="text-white text-center p-3"
            style="
              background-color: rgba(15, 64, 134, 0.733);
              border-radius: 12px;
              margin: 0 32px;
              cursor: pointer;
            "
            @click="openSubscription"
          >
            <span v-if="isLoggedIn">
              {{ $t("Your subscription finished, top-up balance and") }}
              {{ $t("activate subscription") }}.
            </span>
            <span v-else>
              {{ $t("Please login to play this game") }}, {{ $t("click") }}
              {{ $t("here") }} {{ $t("to login") }}.
            </span>
          </h1>
        </div>

        <div
          class="d-flex flex-column flex-md-row justify-content-between gap-4 my-4"
        >
          <!-- Title -->
          <div class="d-flex flex-column mx-2">
            <div class="d-flex justify-content-between">
              <div>
                <h4>{{ game.title }}</h4>
                <p class="small">
                  {{ $t("Played") }} {{ game.views ? game.views : 0 }}
                  {{ $t("times") }}.
                </p>
              </div>
              <div
                class="d-flex align-items-center justify-content-center rounded-circle bg-dark py-2 px-4 d-md-none"
                @click="toggleFullscreen"
              >
                <img src="@/assets/img/game/fullscreen.svg" alt="fullscreen" />
              </div>
            </div>
            <!-- Reviews -->
            <div class="d-flex align-items-center">
              <StarRating
                :rating="game.ratings_avg"
                starSize="18"
                :readonly="true"
              />
              <span class="small">
                {{ game.ratings_avg }} ({{ game.ratings_count }}
                {{ $t("Reviews") }})
              </span>
            </div>
            <!-- Share -->
            <div class="d-flex flex-wrap">
              <img
                src="@/assets/img/share/icons8-facebook-500.png"
                alt="facebook"
                class="cursor-pointer me-2"
                style="width: 40px; height: 40px"
                @click="share('facebook', game)"
              />
              <img
                src="@/assets/img/share/icons8-twitterx-500.png"
                alt="twitter"
                class="cursor-pointer me-2"
                style="width: 40px; height: 40px"
                @click="share('x', game)"
              />
              <img
                src="@/assets/img/share/icons8-instagram.svg"
                alt="instagram"
                class="cursor-pointer me-2"
                style="width: 48px; height: 40px"
                @click="share('instagram', game)"
              />
              <img
                src="@/assets/img/share/icons8-linkedin-500.png"
                alt="linkedin"
                class="cursor-pointer me-2"
                style="width: 40px; height: 40px"
                @click="share('linkedin', game)"
              />
              <img
                src="@/assets/img/share/icons8-whatsapp-500.png"
                alt="whatsapp"
                class="cursor-pointer"
                style="width: 40px; height: 40px"
                @click="share('whatsapp', game)"
              />
            </div>
          </div>
          <div class="p-4 text-center" v-if="isLoggedIn">
            <StarRating
              @input="changeRating"
              starSize="42"
              :rating="userRate"
            />
            <p class="">{{ $t("Rate this game") }}</p>
          </div>

          <!-- Fullscreen Options -->
          <div class="d-none d-md-block mx-2">
            <div
              class="d-flex align-items-center rounded-circle bg-dark py-2 px-4 cursor-pointer"
              @click="toggleFullscreen"
            >
              <img src="@/assets/img/game/fullscreen.svg" alt="fullscreen" />
              <span class="text-white ms-2">{{ $t("Fullscreen") }}</span>
            </div>
          </div>
        </div>
      </section>

      <hr class="bg-secondary my-3" />

      <section>
        <div class="mx-2 my-3">
          <h4 class="my-2">{{ $t("Description") }}:</h4>
          <p class="text-md text-justify text-gray" v-html="game.description"></p>
        </div>
        <div class="mx-2 my-3">
          <h4 class="my-2">{{ $t("Instructions") }}:</h4>
          <p class="text-md text-justify text-gray" v-html="game.instructions"></p>
        </div>
      </section>

      <hr class="bg-secondary my-3" />
    </div>
    <div class="crime-section pb-60" v-if="similarGames.length > 0">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h4 class="left-title">{{ $t("Similar Games") }}</h4>
        </div>
        <MostViews :items="similarGames" />
      </div>
    </div>
    <div class="crime-section pb-60">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h4 class="left-title">{{ $t("New Games") }}</h4>
        </div>
        <NewGames :items="newGames" />
      </div>
    </div>
    <hr class="bg-secondary my-3" />

    <!-- Add comments here... -->
    <section v-if="isLoggedIn || comments.length != 0">
      <div class="mx-3">
        <div class="my-4">
          <div class="d-flex justify-content-between my-4 cursor-pointer">
            <div class="d-flex align-items-center gap-3">
              <div
                class="rounded-circle bg-primary d-flex align-items-center justify-content-center"
                style="width: 40px; height: 40px"
              >
                <img
                  src="http://gamesportal.enthalpytech.com/images/icon/image_6599416c4d5b2.svg"
                  alt="Comments"
                  class="img-fluid"
                />
              </div>
              <h1 class="fs-4 my-0">
                {{ $t("Comments") }}
              </h1>
            </div>
          </div>
          <!-- Add a form to send a comment -->
          <div class="my-2">
            <div class="d-flex flex-column gap-3" v-if="isLoggedIn">
              <div class="d-flex  gap-3">
                <!-- <div
                  class="rounded-circle bg-primary d-flex align-items-center justify-content-center"
                  style="width: 32px; height: 32px"
                >
                  
                </div> -->
                <div class="w-100">
                  <div
                    class="d-flex align-items-center gap-3"
                  >
                  <img
                    v-lazy="userInfo.photo"
                    class="rounded-circle"
                    style="max-width: 32px"
                    alt="Comments"
                  />
                    <h1 class="fs-6 mb-0">
                      {{ userInfo.name || $t("User") + " #" + userInfo.id }}
                    </h1>
                  </div>
                  <form
                    @submit.prevent="onPostComment"
                    class="d-flex flex-column gap-2 mt-2"
                  >
                    <textarea
                      class="form-control"
                      :placeholder="$t('Write a comment...')"
                      v-model="comment"
                      rows="4"
                    ></textarea>
                    <div class="d-flex justify-content-end">
                      <button type="submit" class="btn btn-primary">
                        {{ $t("Send") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="d-flex flex-column gap-3 mt-2"
              v-for="(comment, index) in comments"
              :key="index"
            >
              <div class="d-flex align-items-center gap-3">
                <div class="rounded-circle">
                  <img
                    v-lazy="comment.sender.photo"
                    class="rounded-circle"
                    style="width: 32px; height: 32px"
                    alt="Comments"
                  />
                </div>
                <div class="w-100">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <h3 class="fs-6 mb-0">
                      {{ comment.sender.name || "User #" + comment.sender.id }}
                    </h3>
                    <p class="text-gray fs-7 mb-0">
                      {{ comment.created_date }}
                    </p>
                  </div>
                  <p class="text-gray fs-7">
                    {{ comment.comment }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useGamesStore } from "@/store/games";
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "@/store/auth";
import helpers from "@/helpers";
import StarRating from "@/components/partials/StarRating.vue";
import MostViews from "@/components/partials/GameRowSlider.vue";
import NewGames from "@/components/partials/GameRoundedSlider.vue";

export default {
  name: "GamePage",
  components: {
    StarRating,
    MostViews,
    NewGames,
  },
  data() {
    return {
      play: false,
      close: true,
      canPlay: false,
      comment: "",
    };
  },
  computed: {
    ...mapState(useAuthStore, ["isLoggedIn", "userInfo"]),
    ...mapState(useGamesStore, [
      "game",
      "userRate",
      "newGames",
      "similarGames",
      "voteAction",
      "comments",
    ]),
  },
  methods: {
    ...mapActions(useGamesStore, [
      "fetchGame",
      "voteGame",
      "postComment",
      "rateGame",
    ]),
    ...mapActions(useAuthStore, [
      "openPaymentPage",
      "openLogin",
    ]),
    async changeRating(value) {
      await this.rateGame(this.game.id, value);
      helpers.showToast(
        this.$t("Your rating has been saved successfully"),
        this.$t("Success"),
        "success"
      );
    },
openSubscription() {
  localStorage.setItem("redirectUrl", this.$route.fullPath);

  const config = helpers.getConfig();

  if (!config) {
    helpers.showToast(
      this.$t("Configuration not loaded. Please refresh the page."),
      this.$t("Error"),
      "error"
    );
    return;
  }

  if (config.subscription_type === "card") {
    if (!this.isLoggedIn) {
      this.openLogin();
    } else {
      this.openPaymentPage();
    }
  } else {
    if (config.landing_page_url) {
      window.location.href = config.landing_page_url;
    } else {
      helpers.showToast(
        this.$t("Landing page URL is missing."),
        this.$t("Error"),
        "error"
      );
    }
  }
},
    async onVoteGame(action) {
      await this.voteGame(this.game.id, action);
    },
    async onPostComment() {
      if (!this.comment) {
        helpers.showToast(
          this.$t("Please write a comment before sending it"),
          this.$t("Error"),
          "error"
        );
        return;
      }
      const result = await this.postComment(this.game.id, this.comment);
      this.comment = "";
      if (result) {
        helpers.showToast(
          this.$t("Comment sent successfully"),
          this.$t("Success"),
          "success"
        );
      } else {
        helpers.showToast(
          this.$t("An error occurred while sending the comment"),
          this.$t("Error"),
          "error"
        );
      }
    },
    share(platform, game) {
      if (!game || !game.id) {
        console.error("Game data is undefined or missing required properties.");
        return;
      }

      const url = `${window.location.origin}/game/${this.$route.params.slug}`;
      const title = encodeURIComponent(game.title);

      switch (platform) {
        case "facebook":
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              url
            )}`,
            "_blank"
          );
          break;
        case "x":
          window.open(
            `https://twitter.com/intent/tweet?text=${title}&url=${encodeURIComponent(
              url
            )}`,
            "_blank"
          );
          break;
        case "instagram":
          helpers.showToast(
            this.$t("To share on Instagram, copy the game link and share it on your story or post."),
            this.$t("Success"),
            "success"
          );
          navigator.clipboard.writeText(url);
          break;
        case "whatsapp":
          window.open(
            `https://api.whatsapp.com/send?text=${title} - ${encodeURIComponent(
              url
            )}`,
            "_blank"
          );
          break;
        case "linkedin":
          window.open(
            `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
              url
            )}`,
            "_blank"
          );
          break;
        default:
          console.error("Unsupported platform:", platform);
      }
    },
    toggleFullscreen() {
      const iframe = this.$refs.videoFrame;
      let isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (iframe) {
        if (isIOS) {
          // iOS-specific fullscreen logic
          this.handleIOSFullscreen(iframe);
        } else {
          // Non-iOS fullscreen logic
          if (document.fullscreenElement) {
            // Exit fullscreen if already in fullscreen mode
            if (document.exitFullscreen) {
              document.exitFullscreen();
              this.close = true;
            }
          } else {
            // Enter fullscreen
            if (iframe.requestFullscreen) {
              iframe.requestFullscreen();
              this.close = false;
            }
          }
        }
      }
    },
    toggleFullscreenold() {
      const iframe = this.$refs.videoFrame;

      if (iframe) {
        if (document.fullscreenElement) {
          // Exit fullscreen if already in fullscreen mode
          if (document.exitFullscreen) {
            document.exitFullscreen();
            this.close = true;
          }
        } else {
          // Enter fullscreen
          if (iframe.requestFullscreen) {
            iframe.requestFullscreen();
            this.close = false;
          }
        }
      }
    },
    onEscKey(event) {
      if (event.key === "Escape") {
        // Exit fullscreen mode if in fullscreen
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }

        // If in iOS fullscreen mode, remove the class
        const iframe = this.$refs.videoFrame;
        if (iframe && iframe.classList.contains("ios-fullscreen")) {
          iframe.classList.remove("ios-fullscreen");
        }
      }
    },
    handleIOSFullscreen(iframe) {
      // Toggle the 'ios-fullscreen' class to resize the iframe
      if (!iframe.classList.contains("ios-fullscreen")) {
        iframe.classList.add("ios-fullscreen");
      } else {
        iframe.classList.remove("ios-fullscreen");
      }
    },
  },
  mounted() {
    document.addEventListener("fullscreenchange", this.onFullscreenChange);
    document.addEventListener("keydown", this.onEscKey);
  },

  beforeUnmount() {
    document.removeEventListener("fullscreenchange", this.onFullscreenChange);
    document.removeEventListener("keydown", this.onEscKey);
  },
  async created() {
    await this.fetchGame(this.$route.params.slug);

    this.canPlay = false;

    if (this.game.is_subscription == 0) {
      this.canPlay = true;
    }
    if (this.isLoggedIn && this.game.url && this.userInfo.is_subscribed) {
      this.canPlay = true;
    }
  },
};
</script>

<style>
.ios-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
}

.text-gray {
  color: #A4A4A4 !important;
}

.fs-7 {
  font-size: .875rem;
  line-height: 1.25rem;
}

</style>
